import React from 'react';

export type ImageCelProps = {
  url?: string;
  borderRadius?: number;
  offsetX?: number;
  offsetY?: number;
  adjusting?: boolean;
  widthPx?: number;
  heightPx?: number;
  onLoadNatural?: (w: number, h: number) => void;
  naturalW?: number;
  naturalH?: number;
};

const ImageCel: React.FC<ImageCelProps> = ({ url, borderRadius = 8, offsetX = 0, offsetY = 0, adjusting = false, widthPx, heightPx, onLoadNatural, naturalW, naturalH }) => {
  const src = url || 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&auto=format&fit=crop&q=80';
  const hasDims = typeof widthPx === 'number' && typeof heightPx === 'number' && widthPx! > 0 && heightPx! > 0;
  return (
    <div className="h-full w-full overflow-hidden relative" style={{ borderRadius }}>
      {hasDims ? (
        <img
          src={src}
          alt=""
          className="select-none"
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            width: `${widthPx}px`,
            height: `${heightPx}px`,
            display: 'block',
            maxWidth: 'none',
            maxHeight: 'none',
            transform: `translate(-50%, -50%) translate(${offsetX}px, ${offsetY}px)`,
            willChange: 'transform'
          }}
          onLoad={(e)=>{
            if (!onLoadNatural) return;
            const img = e.currentTarget as HTMLImageElement;
            if (img && img.naturalWidth && img.naturalHeight) onLoadNatural(img.naturalWidth, img.naturalHeight);
          }}
          draggable={false}
        />
      ) : (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover select-none"
          onLoad={(e)=>{
            if (!onLoadNatural) return;
            const img = e.currentTarget as HTMLImageElement;
            if (img && img.naturalWidth && img.naturalHeight) onLoadNatural(img.naturalWidth, img.naturalHeight);
          }}
          draggable={false}
        />
      )}
    </div>
  );
};

export default ImageCel;
